const about = {
  page_title: '关于我们',
  breadcrumb_home: '首页',
  breadcrumb_about: '关于我们',
  section_brand: '品牌介绍',
  section_brand_desc: '伦理在线创立于2018年，是国内领先的伦理学知识与道德教育在线平台。我们致力于推动伦理学知识的大众化传播，为个人和机构的道德发展赋能。',
  brand_story_title: '我们的故事',
  brand_story_p1: '伦理在线诞生于一群伦理学学者和教育工作者的共同愿景：让伦理学走出学术殿堂，走进每一个人的日常生活。在2018年，我们看到了社会对系统化伦理教育的迫切需求——从企业管理的道德困境到人工智能的伦理挑战，从医疗决策的知情同意到环境危机的代际责任，伦理问题无处不在。',
  brand_story_p2: '经过七年的发展，伦理在线已从一个小型学术博客成长为一个拥有38万注册用户、86位专家作者、超过2500篇原创内容的综合性伦理学习平台。我们的内容涵盖伦理理论、应用伦理、职业伦理、案例分析和伦理测评五大领域，为不同背景的学习者提供系统化的伦理教育资源。',
  brand_story_p3: '我们相信，道德不是天生的，而是通过学习和实践培养的。在这个价值多元的时代，伦理在线希望成为每一个思考者的精神家园——在这里，你可以系统学习伦理学知识，深入分析道德困境，不断提升自己的道德判断力和决策能力。',
  brand_mission: '使命',
  brand_mission_text: '推动伦理学知识的大众化传播，帮助个人与机构建立系统的伦理认知体系。',
  brand_vision: '愿景',
  brand_vision_text: '成为中国最值得信赖的伦理学学习与道德教育资源平台。',
  brand_values: '价值观',
  brand_values_text: '学术严谨、开放包容、知行合一、社会责任。',
  section_reputation: '平台声誉',
  section_reputation_desc: '七年来，伦理在线凭借专业的内容和优质的服务赢得了广泛认可',
  rep_item_1_title: '2,560+',
  rep_item_1_desc: '精选文章',
  rep_item_2_title: '380,000+',
  rep_item_2_desc: '平台用户',
  rep_item_3_title: '86位',
  rep_item_3_desc: '专家团队',
  rep_item_4_title: '120门',
  rep_item_4_desc: '精品课程',
  rep_item_5_title: '98%',
  rep_item_5_desc: '用户满意度',
  rep_item_6_title: '50+',
  rep_item_6_desc: '合作机构',
  rep_partner_title: '合作机构',
  rep_partner_1: '北京大学哲学系',
  rep_partner_2: '复旦大学伦理学研究中心',
  rep_partner_3: '中国人民大学伦理学与道德建设研究中心',
  rep_partner_4: '中国伦理学会',
  rep_partner_5: '中国社会科学院哲学研究所',
  rep_partner_6: '清华大学道德与宗教研究院',
  rep_testimonial_1_text: '伦理在线为我们企业的合规培训提供了系统化的伦理教育资源，帮助员工建立了良好的职业道德意识。',
  rep_testimonial_1_name: '刘建国',
  rep_testimonial_1_title: '华远集团人力资源总监',
  rep_testimonial_2_text: '作为高校教师，伦理在线是我备课的重要参考资料。平台的案例分析尤其出色，理论与实践结合得非常紧密。',
  rep_testimonial_2_name: '黄雅琳',
  rep_testimonial_2_title: '南京大学哲学系讲师',
  rep_testimonial_3_text: '通过伦理在线的系统学习，我在处理医疗伦理困境时变得更加从容。平台的内容既有学术深度，又贴近临床实际。',
  rep_testimonial_3_name: '马文博',
  rep_testimonial_3_title: '三甲医院主任医师',
  section_contact: '联系我们',
  section_contact_desc: '有任何问题或合作意向，欢迎与我们取得联系',
  contact_address_label: '地址',
  contact_address: '北京市海淀区中关村南大街5号伦理大厦12层',
  contact_phone_label: '电话',
  contact_phone: '400-888-9999',
  contact_email_label: '邮箱',
  contact_email: 'contact@lunlizx.com',
  contact_wechat_label: '微信公众号',
  contact_wechat: '伦理在线',
  contact_form_name: '姓名',
  contact_form_name_placeholder: '请输入您的姓名',
  contact_form_email: '邮箱',
  contact_form_email_placeholder: '请输入您的邮箱地址',
  contact_form_subject: '主题',
  contact_form_subject_placeholder: '请选择咨询主题',
  contact_form_message: '留言',
  contact_form_message_placeholder: '请输入您想咨询的内容（500字以内）',
  contact_form_submit: '发送留言',
  contact_form_success: '留言发送成功！我们会尽快与您联系。',
  contact_form_error: '发送失败，请稍后重试。',
  subject_option_1: '课程咨询',
  subject_option_2: '合作意向',
  subject_option_3: '专家入驻',
  subject_option_4: '机构服务',
  subject_option_5: '其他问题',
};

export default about;